import { MoreDetailsDialog } from 'app/src/features/UserJoin/components/FirstStep/MoreDetailsDialog'
import { UserJoinConvertDoNotConvert } from 'app/src/features/UserJoin/components/FirstStep/UserJoinConvertDoNotConvert'
import type { PercentageSimulationData } from 'app/src/features/UserJoin/UserJoin'
import { euroFormatterIt } from 'app/src/shared/helpers'
import { Button } from 'primereact/button'
import { Card } from 'primereact/card'
import { useState, type Dispatch, type ReactElement, type SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'

export function FirstStep(
  props: Readonly<{
    formData?: PercentageSimulationData
    setChosenPercentage: Dispatch<SetStateAction<number>>
    setConfirmPercentageDialogVisible: Dispatch<SetStateAction<boolean>>
    chosenPercentage: number
    onNext: () => void
  }>,
): ReactElement {
  const { t } = useTranslation('joinFunnel', { keyPrefix: 'JoinFunnel.FirstStep' })
  const tCommon = useTranslation('joinFunnel', { keyPrefix: 'JoinFunnel.Common' })
  const [showMoreDetailsDialog, setShowMoreDetailsDialog] = useState<boolean>(false)

  return (
    <>
      {showMoreDetailsDialog && (
        <MoreDetailsDialog
          visible={showMoreDetailsDialog}
          setShowMoreDetailsDialog={setShowMoreDetailsDialog}
        ></MoreDetailsDialog>
      )}
      <div className='mb-4 ml-6 mr-6'>
        <h3 className='mb-2 text-center'>{t('title')}</h3>
        <Card className='mx-auto w-96 rounded-3xl border border-[var(--primary-color)] text-center'>
          <div>{t('grossCard.text')}</div>
          <div className='weight-600 mb-2 text-[50px] text-[var(--primary-color)]'>
            {props.formData?.bonusAmount ? euroFormatterIt.format(props.formData?.bonusAmount) : tCommon.t('notAvailableText')}
          </div>
          <div>
            <Button link label={t('grossCard.moreInfoText')} onClick={() => setShowMoreDetailsDialog(true)} />
          </div>
        </Card>
      </div>
      <div className=''>
        <UserJoinConvertDoNotConvert
          accountConvert={props.formData?.simulationData?.premioConvertito}
          nettoConvertitoInWelfare={props.formData?.simulationData?.conversioneInCredito}
          accountDoNotConvert={props.formData?.simulationData?.premioNonConvertito}
          dialogFormData={props.formData}
          setConfirmPercentageDialogVisible={props.setConfirmPercentageDialogVisible}
          setChosenPercentage={props.setChosenPercentage}
          chosenPercentage={props.chosenPercentage}
        />
        <div className='p-4 text-center'>
          <Button className='w-48' label={t('nextBtnLabel')} onClick={() => props.onNext()} rounded />
        </div>
      </div>
    </>
  )
}
